export default {
  once: 'Uma vez',
  interval: 'Intervalo',
  daily: 'Diário',
  weekly: 'Semanal',
  monthly: 'Mensal',
  yearly: 'Anual',
};
